var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCone20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 311",
    d: "M7.40093 4.85767L4.05935 10.4641L1.08905 15.8106L1.68311 16.9988L5.24747 18.1869L9.99994 18.7809L14.7524 18.1869L18.3168 16.9988L18.9108 15.8106L15.6806 10.2785L12.8589 6.34282L9.70291 0.625L7.40093 4.85767Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 72",
    d: "M18.8798 15.8106C18.8798 16.0598 18.7473 16.372 18.3432 16.7303C17.9398 17.088 17.3204 17.4386 16.5014 17.7457C14.8679 18.3583 12.5694 18.7499 9.99982 18.7499C7.43021 18.7499 5.1317 18.3583 3.49826 17.7457C2.67923 17.4386 2.05985 17.088 1.65645 16.7303C1.25232 16.372 1.11987 16.0598 1.11987 15.8106C1.11987 15.5614 1.25232 15.2491 1.65645 14.8908C2.05985 14.5332 2.67923 14.1825 3.49826 13.8754C5.1317 13.2629 7.43021 12.8712 9.99982 12.8712C12.5694 12.8712 14.8679 13.2629 16.5014 13.8754C17.3204 14.1825 17.9398 14.5332 18.3432 14.8908C18.7473 15.2491 18.8798 15.5614 18.8798 15.8106Z",
    fill: "#00C2FF",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 309",
    d: "M1.14459 15.5694L9.70276 0.959229L18.8086 15.4116",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone20);
export default __webpack_public_path__ + "static/media/cone_20.ccf612c29230f01687ebbca7e662a4da.svg";
export { ForwardRef as ReactComponent };